import React from 'react';
import { useTranslation } from 'react-i18next';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import SocialMenu from '../Social';
import { LanguageSwitcher, RecursiveMenu } from '../../../components';
import { ReactComponent as NWOLogo } from '../../../assets/images/NWO_logo.svg';

import './style.scss';

const FooterMenu = () => {
  const { t } = useTranslation();

  return (
    <div className="FooterMenu">
      <div className="FooterMenu__main-section">
        <Container>
          <div className="row">
            <div className="col-12 col-lg-9 offset-lg-1">
              <div className="FooterMenu__main-section__footer-menu">
                <RecursiveMenu
                  menuId="footer"
                  maxLevel={2}
                  linkIconName="chevron_right"
                  withHeading
                  navProps={{ 'aria-label': t('recursive_menu.footer.aria_label') }}
                />
              </div>
            </div>
            <div className="col-12 col-lg-2">
              <div className="FooterMenu__main-section__social">
                <SocialMenu />
              </div>
            </div>
          </div>
        </Container>
      </div>
      <div className="FooterMenu__bottom-section">
        <Container>
          <div className="row">
            <div className="col-12 col-lg-10 offset-lg-1">
              <div className="FooterMenu__bottom-section__wrapper">
                <LanguageSwitcher />
                <RecursiveMenu
                  menuId="legal"
                  maxLevel={1}
                  navProps={{ 'aria-label': t('recursive_menu.legal.aria_label') }}
                />
                <div className="FooterMenu__bottom-section__nwo">
                  <NWOLogo role="img" title={t('footer.nwo_logo')} />
                  <span>
                    {t('footer.nwo')}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </div>
    </div>
  );
};


export default FooterMenu;
